<div class="generic-modal-root">  
    <div class="row-padding">
      <div class="row" style="margin-top: 0; display: block;">
        <form
          class="m-form m-form--fit m-form--label-align-right"
        >
          <div class="form-group m-form__group cancel-title">
            <label style="font-size: 30px;"> Are you sure? </label>
          </div>

          <div *ngIf="!reversing && !cancelling" class="form-group m-form__group cancel-row options">
            <button class="btn btn-danger" style="margin: 10px;" (click)="cancelling = true;">Cancel Subscription</button>
            <button class="btn btn-danger" style="margin: 10px;" (click)="reversing = true;" >Reverse Charges</button>
          </div>

          <div *ngIf="reversing || cancelling" class="form-group m-form__group cancel-row">
            <label *ngIf="cancelling" class="cancel-desc">By clicking 'Confirm', you will cancel all selected subscriptions.</label>
            <label *ngIf="reversing" class="cancel-desc">By clicking 'Confirm', you will reverse all charges for the selected subscriptions.</label>
            <div *ngFor="let subscription of subscriptions; let i = index;" style="display: flex;">
                <chunky-check-box [checked]="selectedSubscriptions.includes(subscription)" (changed)="onSelectSubscription(subscription)"></chunky-check-box>
                <label style="margin-left: 5%;">
                    {{subscription.pledgePerWin.event.name}}
                </label>
            </div>
            <label *ngIf="subscriptions.length < 1" style="text-align: left; margin-bottom: 30px;">This user doesn't have any active subscriptions.</label>
          </div>
  
          <div class="cancel-buttons">
            <button
              *ngIf="reversing"
              [disabled]="selectedSubscriptions.length < 1"
              [debounceClick]
              (click)="reverseAndClose()"
              class="btn btn-success"
              style="margin:10px; float:right"
            >
              Confirm
            </button>
            <button
              *ngIf="cancelling"
              [disabled]="selectedSubscriptions.length < 1"
              [debounceClick]
              (click)="cancelAndClose()"
              class="btn btn-success"
              style="margin:10px; float:right"
            >
              Confirm
            </button>
            <button
              (click)="close()"
              class="btn btn-success"
              style="margin:10px; float:right"
            >
              Close
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>